import React from 'react'

const componentPromise = import('./contact' /* webpackChunkName: "contactPage"*/)

const Component = React.lazy(() => componentPromise)

export default Component